"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const uom_1 = require("@genesys/uom");
const materials = {
    NONE: 0,
    CU: 1,
    AL: 2,
    INOX: 3,
    ALPR: 4,
    CUSN: 5,
    FE: 6,
    FEZN: 7,
    ALMG: 9,
    CUNI9010: 10,
    CUNI7030: 11,
    INOX316: 17,
    OTTONE: 18,
    TITANIO: 22,
    CUFINNED: 24
};
const connectionSides = {
    SAME: 1,
    OPPOSITE: 2
};
const exchangerFlows = {
    COUNTERFLOW: 1,
    COCURRENTFLOW: 2,
    CROSSFLOW: 3
};
function parse(geometry, fluidCoil) {
    const units = geometry[0].map((g) => uom_1.Serialize.stringToUnit(g.substring(1, g.length - 1)));
    const names = geometry[1].map((g) => g.toLowerCase());
    return geometry.slice(2).map((g) => {
        const parseNumber = createParseNumber(g, names);
        const parseText = createParseText(g, names);
        const parseAmount = createParseAmount(g, units, names);
        return {
            id: parseText("id"),
            geometry: {
                tubes: parseNumber("nrOfTubeInHeight"),
                circuits: parseNumber("circuits"),
                rows: parseNumber("tubeRows"),
                finSpacing: parseAmount("finSpacing"),
                tubeLength: parseAmount("tubeLength"),
                tube: {
                    materialThermalConductivity: parseAmount("tubeMaterialThermalConductivity"),
                    materialType: parseMaterial(parseText("tubeMaterial")),
                    thickness: parseAmount("tubeThickness"),
                    externalDiameter: parseAmount("tubeExternalDiameter"),
                    fouling: parseNumber("tubeFouling")
                },
                fin: {
                    materialThermalConductivity: parseAmount("finMaterialThermalConductivity"),
                    thickness: parseAmount("finThickness"),
                    fouling: parseNumber("finFouling")
                },
                distanceBetweenRows: parseAmount("distanceBetweenRows"),
                distanceBetweenTubes: parseAmount("distanceBetweenTubes"),
                connectionSide: parseConnectionSide(parseText("connectionSide")),
                exchangerFlow: parseExchangerFlow(parseText("exchangerFlowType")),
                staggered: parseBoolean(parseText("staggered")),
                inletCollector: {
                    materialType: parseMaterial(parseText("inletCollectorMaterial")),
                    quantity: parseNumber("noOfInletCollectors"),
                    thickness: parseAmount("inletCollectorThickness"),
                    diameter: parseAmount("inletCollectorDiameter")
                },
                outletCollector: {
                    materialType: parseMaterial(parseText("outletCollectorMaterial")),
                    quantity: parseNumber("noOfOutletCollectors"),
                    thickness: parseAmount("outletCollectorThickness"),
                    diameter: parseAmount("outletCollectorDiameter")
                },
                inletHeader: fluidCoil
                    ? {
                        materialType: parseMaterial(parseText("inletHeaderMaterial")),
                        quantity: parseNumber("noOfInletHeaders"),
                        thickness: parseAmount("inletHeaderThickness"),
                        diameter: parseAmount("inletHeaderDiameter")
                    }
                    : null,
                outletHeader: fluidCoil
                    ? {
                        materialType: parseMaterial(parseText("outletHeaderMaterial")),
                        quantity: parseNumber("noOfOutletHeaders"),
                        thickness: parseAmount("outletHeaderThickness"),
                        diameter: parseAmount("outletHeaderDiameter")
                    }
                    : null,
                coeffInput: {
                    aDry: 1,
                    aWet: 1,
                    bDry: 1,
                    bWet: 1,
                    cDry: 1,
                    cWet: 1,
                    dDry: 1,
                    dWet: 1
                }
            }
        };
    });
}
function indexFromName(name, names) {
    const maybeIndex = names.indexOf(name.toLowerCase());
    if (!~maybeIndex) {
        throw new Error("Missing column: " + name);
    }
    return maybeIndex;
}
function createParseNumber(row, names) {
    return (name) => parseFloat(row[indexFromName(name, names)]);
}
function createParseText(row, names) {
    return (name) => row[indexFromName(name, names)];
}
function createParseAmount(row, units, names) {
    return (name) => {
        const index = indexFromName(name, names);
        const unit = units[index];
        if (!unit) {
            throw new Error("Geometry: Unknown unit at column index: " + index);
        }
        const amount = row[index];
        const value = parseFloat(amount);
        return uom_1.Serialize.amountToString(uom_1.Amount.create(value, unit));
    };
}
function parseMaterial(material) {
    const mat = materials[material.toUpperCase()];
    if (mat === undefined) {
        throw new Error("Unknown material");
    }
    return mat;
}
function parseConnectionSide(connectionSide) {
    const connSide = connectionSides[connectionSide.toUpperCase()];
    if (connSide === undefined) {
        throw new Error("Unknown connection side");
    }
    return connSide;
}
function parseExchangerFlow(exchangerFlow) {
    const exFlow = exchangerFlows[exchangerFlow.toUpperCase()];
    if (exFlow === undefined) {
        throw new Error("Unknown exchanger flow type");
    }
    return exFlow;
}
function parseBoolean(bool) {
    const upperBool = bool.toUpperCase();
    if (upperBool === "TRUE") {
        return true;
    }
    if (upperBool === "FALSE") {
        return false;
    }
    throw new Error("Unknown boolean value");
}
//# sourceMappingURL=parse-geometry2.js.map